export const vector = {
  it: {
    hero: {
      title: "Il motore che lavora",
      titleHighlight: "mentre tu riposi.",
      subtitle: "Vector non è un software. È un'infrastruttura operativa autonoma. Collega email, ordini e clienti in un unico flusso intelligente che non richiede la tua supervisione costante.",
      cta: "Installa Vector",
      chat: "Chat Diretta",
      badge: "ENTERPRISE CORE v2.0",
      status: "ONLINE",
      systemStatus: "System Status:"
    },
    heroHighlights: [
      {
        chip: 'Governance',
        title: 'Una console per ogni sede',
        body: 'Ogni workflow approvativo è modellato, auditabile e visibile. Fine alle email in CC e ai “chi approva?”.'
      },
      {
        chip: 'Cortex',
        title: 'AI che ragiona con i tuoi dati',
        body: 'Cortex sintetizza segnali da mail, chat e BI: suggerisce priorità e instrada automaticamente gli step critici.'
      },
      {
        chip: 'Time-to-value',
        title: 'Rollout in 14 giorni',
        body: 'Template pronti per acquisti, onboarding, ticket escalation e qualità. Completamente personalizzabile.'
      }
    ],
    capabilities: [
      {
        title: 'Workflow senza codice',
        body: 'Disegna flussi approvativi e task visivamente. Ogni passaggio ha ruoli, SLA e fallback automatici.'
      },
      {
        title: 'Assistenti operativi',
        body: 'Bot nativi collegano email, ERP, fogli Excel e WhatsApp per eliminare attività manuali.'
      },
      {
        title: 'Alert predittivi',
        body: 'Vector misura colli di bottiglia in tempo reale e invia segnali prima che i tempi si blocchino.'
      }
    ],
    ui: {
      badge: "INTERFACE",
      title: "Workflow reali, visuali reali.",
      description: "La console operativa che utilizziamo ogni giorno per togliere le approvazioni dal caos delle email. Pulita, veloce, scura.",
      bullets: [
        'Pannello amministratore con SLA, priorità e approvatori visibili in un colpo d’occhio.',
        'Form di creazione richiesta con campi condizionali, allegati e timeline automatica.',
        'Branding Vector pronto al white-label per rollout su più business unit.'
      ]
    },
    architecture: {
      title: "Architettura del Sistema",
      subtitle: "Costruito su fondamenta Enterprise-Grade.",
      sections: [
        {
          title: 'Backend modulare',
          items: [
            'NestJS · Prisma · Supabase (PostgreSQL)',
            'API GraphQL + REST con RLS per multitenancy',
            'Domini: utenti, workflow, step, istanze, eventi, notifiche'
          ]
        },
        {
          title: 'Frontend dinamico',
          items: [
            'React + Vite + TypeScript con TanStack Query',
            'Schema UI dinamico: i form si adattano al workflow',
            'Interfacce basate sul ruolo (Owner · Agent · Viewer)'
          ]
        },
        {
          title: 'Infrastruttura cloud',
          items: [
            'Supabase Auth + Realtime',
            'Azure App Services (API) & Static Web Apps (UI)',
            'Integrazioni opzionali: n8n, Microsoft Graph, OpenAI, Slack, WhatsApp'
          ]
        }
      ]
    },
    roadmap: {
      title: "Sequence of Operations",
      items: [
        { phase: 'I', title: 'Schema & RLS', status: 'Completo' },
        { phase: 'II', title: 'Moduli API NestJS', status: 'Completo' },
        { phase: 'III', title: 'UI React & dashboard', status: 'Completo' },
        { phase: 'IV', title: 'Layer AI Assist', status: 'In corso' },
        { phase: 'V', title: 'Automazione SaaS', status: 'Pianificato' }
      ]
    },
    future: {
      badge: "Long Term Vision",
      title: "Verso un tessuto cognitivo",
      cta: "Vector diventa la piattaforma che connette agenti umani e AI. Vuoi essere tra i primi dodici partner beta?",
      button: "Prenota Call Strategica",
      bullets: [
        'Deployment auto-replicante: crea nuovi tenant con una chiamata API.',
        'Orchestrazione cognitiva: agenti AI suggeriscono o eseguono step in autonomia.',
        'Integrazioni dichiarative: connetti API esterne con definizioni YAML-like.',
        'Ragionamento grafo: analisi dei colli di bottiglia con embedding AI e metriche predittive.'
      ]
    },
    form: {
      title: "Richiedi Accesso al Core",
      subtitle: "Slot limitati per il Q3. Priorità ai partner esistenti.",
      email: "Email Aziendale",
      name: "Nome Completo",
      company: "Nome Azienda",
      role: "Ruolo",
      nightmare: "Qual è il processo più lento oggi?",
      button: "INIZIALIZZA RICHIESTA",
      processing: "INITIALIZING...",
      success: {
        title: "Accesso Registrato",
        message: "Il tuo ID richiesta è stato generato. Un architetto del sistema ti contatterà entro 24 ore.",
        button: "CHIUDI TERMINALE"
      },
      error: "Errore durante la registrazione. Riprova più tardi."
    },
    coreModules: "Core Modules"
  },
  en: {
    hero: {
      title: "The engine that works",
      titleHighlight: "while you rest.",
      subtitle: "Vector is not software. It is an autonomous operating infrastructure. It connects email, orders, and customers into a single intelligent flow that does not require your constant supervision.",
      cta: "Deploy Vector",
      chat: "Direct Chat",
      badge: "ENTERPRISE CORE v2.0",
      status: "ONLINE",
      systemStatus: "System Status:"
    },
    heroHighlights: [
      {
        chip: 'Governance',
        title: 'One console, every site',
        body: 'Approval workflows become modelled, auditable, and visible. End the “who approves?” email chaos.'
      },
      {
        chip: 'Cortex',
        title: 'AI that reasons with your signals',
        body: 'Cortex digests mail, chat, and BI streams to prioritise, summarise, and auto-route the critical steps.'
      },
      {
        chip: 'Time-to-value',
        title: '14-day rollout',
        body: 'Ready-made blueprints for purchasing, onboarding, escalations, and quality. Fully customisable for your org.'
      }
    ],
    capabilities: [
      {
        title: 'No-code orchestration',
        body: 'Design approval and task flows visually. Every stage carries owners, SLAs, and automatic fallbacks.'
      },
      {
        title: 'Operational copilots',
        body: 'Native bots connect email, ERP, spreadsheets, and WhatsApp so manual busywork disappears.'
      },
      {
        title: 'Predictive alerts',
        body: 'Vector monitors bottlenecks in real-time and flags delays before your process stalls.'
      }
    ],
    ui: {
      badge: "INTERFACE",
      title: "Real workflows, real visuals.",
      description: "The operational console we use daily to remove approvals from email chaos. Clean, fast, dark.",
      bullets: [
        'Admin console exposes SLAs, priorities, and approvers at a glance.',
        'Request creation form with conditional fields, attachments, and auto timeline.',
        'Vector branding ready for white-label rollouts across business units.'
      ]
    },
    architecture: {
      title: "System Architecture",
      subtitle: "Built on Enterprise-Grade foundations.",
      sections: [
        {
          title: 'Modular backend',
          items: [
            'NestJS · Prisma · Supabase (PostgreSQL)',
            'GraphQL + REST APIs with RLS-driven multitenancy',
            'Domains: users, workflows, steps, transitions, instances, assignments, notifications'
          ]
        },
        {
          title: 'Dynamic front-end',
          items: [
            'React + Vite + TypeScript with TanStack Query',
            'Schema-driven UI rendering for any form payload',
            'Role-adaptive experiences (Owner · Agent · Viewer)'
          ]
        },
        {
          title: 'Cloud infrastructure',
          items: [
            'Supabase Auth + Realtime',
            'Azure App Services (API) & Static Web Apps (UI)',
            'Optional bridges: n8n, Microsoft Graph, OpenAI, Slack, WhatsApp'
          ]
        }
      ]
    },
    roadmap: {
      title: "Execution Sequence",
      items: [
        { phase: 'I', title: 'DB schema & RLS', status: 'Complete' },
        { phase: 'II', title: 'NestJS API modules', status: 'Complete' },
        { phase: 'III', title: 'React UI & dashboard', status: 'Complete' },
        { phase: 'IV', title: 'AI assistant layer', status: 'In progress' },
        { phase: 'V', title: 'SaaS provisioning', status: 'Planned' }
      ]
    },
    future: {
      badge: "Long Term Vision",
      title: "Building the cognitive workflow fabric",
      cta: "Vector is the platform stitching human and machine agents together. Want to join the first twelve design partners?",
      button: "Schedule Strategy Call",
      bullets: [
        'Self-replicating deployments: spawn new tenants or instances with a single API call.',
        'Cognitive orchestration: AI models propose or auto-execute workflow steps when confident.',
        'Declarative integrations: connect external APIs via YAML-like flow definitions.',
        'Graph reasoning: diagnose bottlenecks with AI embeddings and predictive metrics.'
      ]
    },
    form: {
      title: "Request Core Access",
      subtitle: "Limited slots for Q3. Priority to existing partners.",
      email: "Business Email",
      name: "Full Name",
      company: "Company Name",
      role: "Role",
      nightmare: "What is the slowest process today?",
      button: "INITIALIZE REQUEST",
      processing: "INITIALIZING...",
      success: {
        title: "Access Registered",
        message: "Your request ID has been generated. A system architect will contact you within 24 hours.",
        button: "CLOSE TERMINAL"
      },
      error: "Error during registration. Please try again later."
    },
    coreModules: "Core Modules"
  }
};